import { Box, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import i18n from 'modules/core/lib/i18n'

interface Props {
  value: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}

export const AgreementEsignatureToggle: React.FC<Props> = ({ value, disabled, onChange }) => (
  <Box gap="s8">
    <Text.Normal size="200" weight="semibold" color="textPrimary">
      {i18n.t('performance_process.agreements.esignature_settings.title')}
    </Text.Normal>
    <Box gap="s8" flexDirection="row" alignItems="center">
      <TogglerCheckbox
        value={value}
        onChange={() => onChange(!value)}
        disabled={disabled}
        aria-label={i18n.t(
          'performance_process.agreements.esignature_settings.toggle_checkbox_label'
        )}
      />
      <Box flexDirection="row" alignItems="center" gap="s4">
        <Text.Normal size="200">
          {i18n.t('performance_process.agreements.esignature_settings.description')}
        </Text.Normal>
        <HelpCenterLink name="esignature">
          {i18n.t('performance_process.agreements.esignature_settings.learn_more')}
        </HelpCenterLink>
      </Box>
    </Box>
  </Box>
)
